'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useAppSelector } from '@/lib/redux/hooks';
import { getTotalPrice } from '@/lib/redux/features/cart';

const CartTotal = () => {
  const cart = useAppSelector((state) => state.cart.items); // Get items array
  const coupon = useAppSelector((state) => state.coupon.code); // Get items array

  const subtotal = getTotalPrice(cart); // Sum of all item prices
  const discount = 15;
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null; // or a loading spinner
  }
  return (
    <div className="cart__total">
      <h3>Cart Total</h3>
      <div className="cart__total-data">
        <span>Subtotal</span>
        <span>${subtotal.toFixed(2)}</span>
      </div>
      <div className="cart__total-data">
        <span>Discount</span>
        <span>-${discount.toFixed(2)}</span>
      </div>
      {coupon && (
        <div className="cart__total-data">
          <span>Coupon</span>
          <span>-${10.0}</span>
        </div>
      )}
      <div className="cart__total-data cart__total-data--total">
        <span>Total</span>
        <span>
          $
          {coupon
            ? Math.abs(subtotal - discount - 10)
            : Math.abs(discount - subtotal)}
        </span>
      </div>
      <Link href="/checkout" className="trk-btn trk-btn--primary">
        Proceed to checkout
      </Link>
    </div>
  );
};

export default CartTotal;
